<template>
	<div class="ttshop_sing">
		<Singinheader :headertext="texted"></Singinheader>
		<div class="ttshop_singcon">
			<div class="ttshop_singconter w">
				<div class="ttshop_register">
					<!-- 错误提示 -->
					<div class="ttshop_singtop" :class="{ttshop_singtop_active:iShow}">
						<p>
							<i>
								<img class="img-default" src="../../assets/images/ttshop_samil.png" alt />
							</i>
							<span>{{title}}</span>
						</p>
					</div>
					<ul>
						<li>
							<!-- @blur="animateWidth()" -->
							<input type="text" :model="name" ref="name" v-on:input="animateWidth()" placeholder="输入手机号码" class="ttshop_remobile"
							 maxlength="11" />
						</li>
						<li>
							<input type="text" placeholder="手机验证码" :model="verification" ref="verification" class="ttshop_reyzm" />
							<template v-if="show">
								<div class="ttshop_reyzmbut d-flex align-items-center justify-content-center" v-if="success" @click="getCode">获取验证码</div>
								<div class="ttshop_reyzmbut d-flex align-items-center justify-content-center" v-else>获取验证码</div>
							</template>
							<template v-if="!show">
								<div class="ttshop_reyzmbut d-flex align-items-center justify-content-center">{{count}}秒后重新发送</div>
							</template>
						</li>
						<li>
							<input type="password" maxlength="16" @blur="passwordLose" :model="password" ref="password" placeholder="请输入密码"
							 class="ttshop_repassword" />
						</li>
						<li>
							<input type="password" maxlength="16" @blur="passwordsLose" :model="passwords" ref="passwords" placeholder="再次输入密码"
							 class="ttshop_repassword" v-bind:disabled="disabled" />
						</li>
						<!-- <li class="ttshop_rechecked" >
              <el-checkbox v-model="checked">我已阅读并接受</el-checkbox>
              <span>《用户协议》</span>
            </li>-->
						<li>
							<button class="ttshop_registerlast" @click="registerBtn">立即注册</button>
						</li>
						<li>
							<router-link to="/signin">已有账号，去登录</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<Foot :footerhidden="false"></Foot>

		<!-- 注册协议 -->
		<div class="ttshop_agreement" v-show="agreement">
			<div class="ttshop_agreementbj"></div>
			<div class="ttshop_agreementbox">
				<div class="ttshop_agreementitle clearfloat">
					<h5>{{agreementList.title}}</h5>
					<router-link to="/" replace></router-link>
				</div>
				<div class="ttshop_agreementext" v-html="agreementList.content">

				</div>
				<div class="ttshop_agreementbut">
					<button @click="closeAgreement">同意并继续</button>
				</div>
			</div>
		</div>
		<!-- 图片验证 -->
		<div class="ttshop_yanzheng" v-show="verify">
			<div class="ttshop_yanzhengbj"></div>
			<div class="ttshop_yanzhengbox">
				<slide-verify ref="slideblock" @success="onSuccess" @again="onAgain" @fulfilled="onFulfilled" @fail="onFail"
				 @refresh="onRefresh" :slider-text="text" :imgs="imgs" :accuracy="accuracy"></slide-verify>
				<div class="ttshop_yanzhengclose" @click="closeVerify">
					<img class="img-default" src="../../assets/images/ttshop_colse.png" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Singinheader from "./components/singinheader";
	import Foot from "@/components/foot/foot";

	import img0 from "../../assets/images/img.jpg";
	import img1 from "../../assets/images/img1.jpg";
	import img2 from "../../assets/images/img2.jpg";
	import img3 from "../../assets/images/img3.jpg";
	import img4 from "../../assets/images/img4.jpg";
	import img5 from "../../assets/images/img5.jpg";
	import {
		Base64
	} from "js-base64";
	import md5 from "js-md5";
	export default {
		components: {
			Singinheader,
			Foot,
		},
		data() {
			return {
				texted: "欢迎注册",
				checked: false,
				name: "",
				title: "",
				iShow: false,
				password: "",
				passwords: "",
				verification: "",
				disabled: true,
				show: true,
				count: "",
				timer: null,
				text: "向右滑动->",
				imgs: [img0, img1, img2, img3, img4, img5],
				accuracy: 5,
				verify: false,
				agreement: true,
				agreementList: "",
				success: false,
			};
		},
		mounted() {},
		created() {
			this.gainAgreement();
		},
		methods: {
			// 图形验证
			onSuccess(times) {
				this.handleClick();
				this.resSale();
				this.msg = `login success, 耗时${(times / 1000).toFixed(1)}s`;
				this.verify = false;
			},
			//关闭图形验证
			closeVerify() {
				this.verify = false;
			},
			onFail() {
				console.log("验证不通过");
				this.msg = "";
			},
			onRefresh() {
				console.log("点击了刷新小图标");
				this.msg = "";
			},
			onFulfilled() {
				console.log("刷新成功啦！");
			},
			onAgain() {
				console.log("检测到非人为操作的哦！");
				this.msg = "try again";
				// 刷新
				this.handleClick();
			},
			handleClick() {
				this.$refs.slideblock.reset();
				this.msg = "";
			},
			// 手机号失焦事件
			animateWidth() {
				let _this = this;
				let num = _this.$refs.name.value;
				if (num == "") {
					_this.iShow = false;
					return;
				}
				if (num.length == 11) {
					if (!/^1[3456789]\d{9}$/.test(num)) {
						_this.title = "请输入正确手机号";
						_this.iShow = true;
					} else {
						_this.$api.whether({
							mobile: num,
						}).then((res) => {
							if (!res.data) {
								_this.title = "手机号已被注册";
								_this.iShow = true;
								_this.success = false;
							} else {
								_this.iShow = false;
								_this.success = true;
							}
						}).catch((err) => {
							console.log(err);
						});
					}
				} else {
					// _this.title = "手机号已被注册";
					_this.iShow = false;
				}
			},
			// 密码失焦事件
			passwordLose() {
				let password = this.$refs.password.value;
				let passwords = this.$refs.passwords.value;
				if (password == "") {
					this.iShow = false;
					this.disabled = true;
					return;
				}
				if (password.length < 6) {
					this.title = "请将密码设置为6-16位";
					this.iShow = true;
				} else {
					this.disabled = false;
					this.iShow = false;
				}
			},
			// 确认密码失焦事件
			passwordsLose() {
				let password = this.$refs.password.value;
				let passwords = this.$refs.passwords.value;
				if (password != passwords) {
					this.title = "两次输入密码不一致";
					this.iShow = true;
				} else {
					this.iShow = false;
				}
			},
			// 获取验证码
			getCode() {
				if (this.success) {
					this.verify = true;
				} else {
					this.title = "请输入手机号";
					this.iShow = true;
				}
			},
			// 关闭用户协议
			closeAgreement() {
				this.agreement = false;
			},
			// 获取用户协议
			gainAgreement() {
				this.$api.articleDetail({
					id: "about_privacy",
				}).then((res) => {
					this.agreementList = res.data;
				}).catch((err) => {
					console.log(err);
				});
			},
			//获取验证码
			resSale() {
				let _this = this;
				let phone_number = _this.$refs.name.value;
				var time = Date.parse(new Date()) / 1000;
				this.dateFormat('y*m=dh&i#s', new Date());
				var date = _this.formatStr;
				var first = phone_number.substr(1, 4);
				var end = phone_number.substr(phone_number.length - 4);
				var sign = Base64.encode(md5(first + date + end + phone_number + time));
				_this.$api.resSale({
					mobile: phone_number,
					sign_time: time,
					sign: sign
				}).then((res) => {
					// this.movies = res.data;
					// _this.agreementList = res.data;
					_this.$api.sendCode({
						mobile: phone_number,
						token: res.data.token,
					}).then((res) => {
						const TIME_COUNT = 60;
						if (!this.timer) {
							this.count = TIME_COUNT;
							this.show = false;
							this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--;
								} else {
									this.show = true;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000);
						}
					}).catch((err) => {
						this.common.message(this,err);
					});
				}).catch((err) => {
					console.log(err);
				});
			},
			dateFormat(formatStr, fdate) {
				var fTime, fStr = 'ymdhis';
				if (!formatStr)
					formatStr = "y/m/d-h:i:s";
				if (fdate) {
					fTime = new Date(fdate);
				} else {
					fTime = new Date();
				}
				var formatArr = [
					fTime.getFullYear().toString(),
					(fTime.getMonth() + 1).toString() < 10 ? '0' + (fTime.getMonth() + 1).toString() : (fTime.getMonth() + 1).toString(),
					fTime.getDate().toString() < 10 ? '0' + fTime.getDate().toString() : fTime.getDate().toString(),
					fTime.getHours().toString() < 10 ? '0' + fTime.getHours().toString() : fTime.getHours().toString(),
					fTime.getMinutes().toString() < 10 ? '0' + fTime.getMinutes().toString() : fTime.getMinutes().toString(),
					fTime.getSeconds().toString() < 10 ? '0' + fTime.getSeconds().toString() : fTime.getSeconds().toString()
				];
				for (var i = 0; i < formatArr.length; i++) {
					formatStr = formatStr.replace(fStr.charAt(i), formatArr[i]);
				}
				this.formatStr = formatStr;
			},
			//注册
			register() {
				let _this = this;
				_this.$api.register({
					mobile: _this.$refs.name.value,
					mobile_code: _this.$refs.verification.value,
					password: _this.$refs.password.value,
					password_again: _this.$refs.passwords.value,
				}).then((res) => {
					if(res.code==0){
						_this.$store.commit("userInfo", res.data);
						_this.$router.replace("/");
					}else{
						_this.title = res.msg;
						_this.iShow = true;
					}
					

					// this.movies = res.data;
					// _this.agreementList = res.data;
				}).catch((err) => {
					console.log(err.msg);
					_this.title = err.msg;
					_this.iShow = true;
				});
			},
			//注册按钮
			registerBtn() {
				let _this = this;
				let name = _this.$refs.name.value;
				let password = _this.$refs.password.value;
				let passwords = _this.$refs.passwords.value;
				let verification = _this.$refs.verification.value;
				if (name == "") {
					_this.title = "请输入手机号";
					_this.iShow = true;
				} else if (password == "") {
					_this.title = "请输入密码";
					_this.iShow = true;
				} else if (verification == "") {
					_this.title = "请输入验证码";
					_this.iShow = true;
				} else {
					_this.register();
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.ttshop_singheader {
		box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.07);
	}

	.ttshop_singtop_active {
		opacity: 1 !important;
	}

	.ttshop_sing {
		width: 100%;

		.ttshop_singcon {
			width: 100%;
			height: 500px;

			.ttshop_register {
				width: 380px;
				margin: 0 auto;
				padding-top: 104px;
				box-sizing: border-box;

				.ttshop_singtop {
					width: 100%;
					height: 30px;
					background: #fff0f1;
					padding: 0 15px;
					line-height: 30px;
					margin: 8px 0;
					box-sizing: border-box;
					opacity: 0;

					p {
						i {
							display: inline-block;
							width: 12px;
							height: 12px;
							border-radius: 50%;
							margin-right: 6px;
							vertical-align: -2px;

							img {
								display: block;
								width: 100%;
								height: 100%;
								border-radius: 50%;
							}
						}

						span {
							font-size: 12px;
							color: #ff0e25;
						}
					}
				}

				ul {
					li {
						width: 100%;
						position: relative;
						margin-bottom: 20px;

						input {
							width: 380px;
							height: 40px;
							border: 1px solid #ebebeb;
							padding: 0 20px 0 41px;
							box-sizing: border-box;
							font-size: 12px;
							color: #333;
							border-radius: 2px;
							outline: none;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;

							&:focus {
								border-color: #ff0e25;
							}
						}

						.ttshop_remobile {
							background: url(../../assets/images/ttshop_mobiles.png) 10px center no-repeat;
						}

						.ttshop_reyzm {
							padding-right: 110px;
							background: url(../../assets/images/ttshop_yz.png) 11px center no-repeat;
						}

						.ttshop_repassword {
							background: url(../../assets/images/ttshop_password.png) 11px center no-repeat;
						}

						.ttshop_reyzmbut {
							// display: block;
							min-width: 98px;
							height: 38px;
							border: 0;
							outline: none;
							font-size: 12px;
							color: #333;
							border: 0;
							background: #eeeeee;
							position: absolute;
							top: 1px;
							right: 1px;
							border-radius: 0 2px 2px 0;
							cursor: pointer;
						}

						span {
							font-size: 12px;
							color: #0e9cff;
							cursor: pointer;
						}

						.ttshop_registerlast {
							width: 100%;
							height: 40px;
							font-size: 14px;
							color: #fff;
							border: 0;
							outline: none;
							border-radius: 2px;
							cursor: pointer;
							background: linear-gradient(90deg, #ff9010, #ff0e25);
							background: -moz-linear-gradient(90deg, #ff9010, #ff0e25);
							background: -webkit-gradient(90deg, #ff9010, #ff0e25);
							background: -ms-linear-gradient(90deg, #ff9010, #ff0e25);
							filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;

							&:hover {
								box-shadow: 0 5px 10px rgba(215, 119, 8, 0.5);
							}
						}

						a {
							font-size: 12px;
							color: #ff0e25;
							display: block;
							text-align: center;
						}
					}

					.ttshop_rechecked {
						margin-bottom: 16px;
					}
				}
			}
		}

		.ttshop_yanzheng {
			width: 100%;
			height: 100%;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1000;

			.ttshop_yanzhengbj {
				width: 100%;
				height: 100%;
				position: fixed;
				top: 0;
				left: 0;
				background: rgba(0, 0, 0, 0.4);
			}

			.ttshop_yanzhengbox {
				position: fixed;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				padding: 20px;
				box-sizing: border-box;
				background: #fff;
				border-radius: 8px;

				.ttshop_yanzhengclose {
					height: 12px;
					width: 12px;
					position: absolute;
					top: 5px;
					right: 5px;
				}
			}
		}
	}

	.ttshop_agreement {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1000;

		.ttshop_agreementbj {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.5);
		}

		.ttshop_agreementbox {
			width: 780px;
			height: 500px;
			background: #fff;
			position: fixed;
			top: 50%;
			left: 50%;
			margin-left: -390px;
			margin-top: -250px;
			border: 4px solid rgba(0, 0, 0, 0.4);
			border-radius: 4px;

			.ttshop_agreementitle {
				width: 100%;
				height: 40px;
				line-height: 40px;
				background: #f5f5f5;
				padding: 0 15px;
				box-sizing: border-box;

				h5 {
					float: left;
					font-size: 14px;
					color: #333;
					font-weight: bold;
				}

				a {
					float: right;
					display: block;
					width: 20px;
					height: 20px;
					background: url(../../assets/images/ttshop_colse.png) center no-repeat;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
					outline: none;
					margin-top: 10px;

					&:hover {
						background: url(../../assets/images/ttshop_colsed.png) center no-repeat;
					}
				}
			}

			.ttshop_agreementext {
				width: 100%;
				height: 400px;
				overflow-y: scroll;
				padding: 20px 20px 10px 20px;
				box-sizing: border-box;

				p {
					font-size: 14px;
					color: #333;
					text-indent: 2em;
					line-height: 26px;
				}
			}

			.ttshop_agreementbut {
				width: 100%;
				height: 60px;
				position: absolute;
				bottom: 0;
				left: 0;
				box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

				button {
					display: block;
					width: 180px;
					height: 40px;
					font-size: 14px;
					color: #fff;
					border-radius: 2px;
					outline: none;
					margin: 10px auto 0;
					border: 0;
					cursor: pointer;
					background: #ff0e25;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;

					&:hover {
						box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
					}
				}
			}
		}
	}
</style>
